import React from "react";
import { Wrench, Hammer } from "lucide-react";
import MaintenanceListManager from "./MaintenanceListManager";

const MaintenanceSettings: React.FC = () => {
  return (
    <div className="space-y-6">
      <MaintenanceListManager
        table="maintenance_systems"
        title="Vehicle Systems"
        description="Areas of the vehicle that can have maintenance lodged against them (Lights, Tyres, Body, Interior, Hoist, etc.). These appear in the Maintenance log dropdown."
        icon={<Wrench className="w-5 h-5" />}
        placeholder="e.g. Tyres"
      />
      <MaintenanceListManager
        table="maintenance_work_types"
        title="Work Types"
        description="The kind of work done (Serviced, Replaced, Repaired, COF, Labour, etc.). These appear in the Maintenance log dropdown."
        icon={<Hammer className="w-5 h-5" />}
        placeholder="e.g. Replaced"
      />
    </div>
  );
};

export default MaintenanceSettings;
